import { useState, useEffect } from 'react';
import { API_URLS } from '../../../apiUrl';
import { Pagination } from '@mui/material';
import BoroughEdit from '../../../editModals/boroughEdit';
import axiosInstance from '../../../components/axiosInstance';

const BoroughList = ({ muniCipalityName, muniCipalityId }: any) => {
  const [boroughTableData, setBoroughTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const [inputData, setInputData] = useState({ page: 1, limit: 50 });
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(50);


  useEffect(() => {
    const fetchBorough = async () => {
      setLoading(true); 
      setError("");     // Reset any previous errors
      try {
        const response = await axiosInstance.post(`${API_URLS.GetMunicipalityBorough}`, {
          municipalityTbl_id: muniCipalityId,
          page: inputData.page,
          limit: inputData.limit,
          surveyer_id: 0
        }
      );

        setBoroughTableData(response.data.data.data);
        setTotalItems(response.data.data.total);
      } catch (err) {
        setError('Something went wrong!'); // Handle any errors during the request
      } finally {
        setLoading(false); // Stop loading once the request is completed
      }
    };

    fetchBorough();  // Call the function to fetch data when the component mounts or page changes
  }, [inputData.page]); // Re-run the effect when the page number changes


  // Filtered data based on search query
  const filteredData = boroughTableData.filter((item: any) =>
    item.borough_name?.toLowerCase().includes(searchQuery.toLowerCase()) 
  );






  // pagination //

  const handlePageChange = (event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,  // Update the current page
    }));
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [boroughName, setBoroughName] = useState<any>("");
  const [boroughId, setBoroughId] = useState<any>("");

  // Function to open the modal
  const openModal = (boroughName: any, boroughId: any) => {
    setIsModalOpen(true);
    setBoroughName(boroughName);
    setBoroughId(boroughId);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container mx-auto">
      {/* Search Section */}
      <div className="flex gap-5 mb-4">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Borough List ({muniCipalityName})</h1>

        {/* Search Input */}
        <div className="flex justify-end md:w-4/12 w-full ml-auto">
          <input
            type="text"
            placeholder="Search..."
            className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
            <tr>
              <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough</th>
              <th className="py-3 px-6 text-center text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center">Loading...</td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
              </tr>
            ) : (
              filteredData.map((item: any, index: any) => (
                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.borough_name}</td>
                  <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                    <div className="flex gap-2 justify-center">
                      <button onClick={() => openModal(item.borough_name, item.borough_primary_id)} className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200">
                        <i className="ri-edit-line"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredData?.length === 0 ? null :
        <div className="flex justify-center mt-4">
          {/* Pagination Component */}
          <Pagination
            count={totalPages}  // Set the total pages dynamically based on totalItems
            page={inputData.page}
            onChange={handlePageChange}
            color="primary"
          />
        </div>}

      <BoroughEdit isOpen={isModalOpen} closeModal={closeModal} muniCipalityName={muniCipalityName} muniCipalityId={muniCipalityId} boroughName={boroughName} boroughId={boroughId} />
    </div>
  );
};

export default BoroughList;
